const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || null;

function playBeep() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = 'sine';
    o.frequency.value = 1000;
    o.connect(g);
    g.connect(ctx.destination);
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.1, ctx.currentTime + 0.01);
    o.start();
    setTimeout(() => {
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.05);
      try { o.stop(); } catch {}
    }, 150);
  } catch (err) {
    // ignore audio errors
  }
}

async function showNotification(payload) {
  try {
    if (Notification.permission === 'granted') {
      const title = payload?.subject || 'New mail received';
      const body = payload?.snippet || (payload?.from || 'You') + ' sent a message';
      const n = new Notification(title, { 
        body, 
        tag: `mail-${payload?.id || Date.now()}`,
        actions: [
          { action: 'reply', title: 'Reply' }
        ]
      });
      n.onclick = () => {
        try { window.focus(); } catch {}
      };
    }
  } catch (err) {}
}

async function registerServiceWorkerAndSubscribe(authHeaders) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
  try {
    const reg = await navigator.serviceWorker.register('/sw.js');
    if (!VAPID_PUBLIC_KEY) return reg;
    const existing = await reg.pushManager.getSubscription();
    if (existing) return existing;
    const key = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);
    const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
    // send to server
    try {
      await fetch('/api/push/subscribe', {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeaders || {}),
        body: JSON.stringify({ subscription: sub }),
      });
    } catch (err) {}
    return sub;
  } catch (err) {
    return null;
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function initNotifications(authHeaders) {
  try {
    if (Notification && Notification.permission !== 'granted') {
      try { await Notification.requestPermission(); } catch {}
    }
  } catch {}

  // Listen for reply notification action from service worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'REPLY_NOTIFICATION') {
        // Dispatch custom event so components can handle reply action
        window.dispatchEvent(new CustomEvent('notification-reply', { 
          detail: { notification: event.data.data }
        }));
      }
    });
  }

  window.addEventListener('mail-received', (ev) => {
    try {
      const data = ev?.detail || {};
      playBeep();
      showNotification(data.mail || data);
    } catch (err) {}
  });

  // Quick chat notification
  window.addEventListener('chat-received', (ev) => {
    try {
      const data = ev?.detail || {};
      playBeep();
      // Use a simple payload shape compatible with showNotification
      showNotification({ subject: data.from || 'New message', snippet: data.text || '', id: data.id });
    } catch (err) {}
  });

  // attempt to register SW and subscribe to push (if auth provided)
  if (authHeaders) {
    void registerServiceWorkerAndSubscribe(authHeaders);
  }
}

export default { initNotifications, registerServiceWorkerAndSubscribe };
